<template>
  <div class="tax-table-wrap tax-table-wrap-tax53" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>企业所得税弥补亏损明细表</dt>

      <dd></dd>
    </dl>

    <div class="tax-table-body">
      <table border="1" cellspacing="0" cellpadding="4" tabletype="2024033103">
        <thead>
          <tr>
            <td class="title01" rowspan="3">行次</td>
            <td class="title01" rowspan="3" style="width: 75px">项&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;目</td>
            <td class="title01 niandu" rowspan="2">年度</td>
            <td class="title01" rowspan="2">当年境内所得额</td>
            <td class="title01" rowspan="2">分立转出的亏损额</td>
            <td class="title01" colspan="3">合并、分立转入的亏损额</td>
            <td class="title01" rowspan="2" style="width: 75px">弥补亏损企业类型</td>
            <td rowspan="2" class="title01">当年亏损额</td>
            <td class="title01" rowspan="2">当年待弥补的亏损额</td>
            <td colspan="2" class="title01">用本年度所得额弥补的以前年度亏损额</td>
            <td class="title01" rowspan="2">当年可结转以后年度 弥补的亏损额</td>
          </tr>
          <tr>
            <td class="title01">可弥补年限5年</td>
            <td class="title01">可弥补年限8年</td>
            <td class="title01">可弥补年限10年</td>
            <td class="title01">使用境内所得弥补</td>
            <td class="title01">使用境外所得弥补</td>
          </tr>
          <tr>
            <td class="title01 niandu">1</td>
            <td class="title01">2</td>
            <td class="title01">3</td>
            <td class="title01">4</td>
            <td class="title01">5</td>
            <td class="title01">6</td>
            <td class="title01">7</td>
            <td class="title01">8</td>
            <td class="title01">9</td>
            <td class="title01">10</td>
            <td class="title01">11</td>
            <td class="title01">12</td>
          </tr>
        </thead>
        <tbody>
          <tr class="tr">
            <td class="title01">1</td>
            <td class="title01" style="text-align: center">前十年度</td>
            <td class="niandu">2014</td>
            <td class="d2"><el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v1x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4">--</td>
            <td class="d5">--</td>
            <td class="d6"><el-input-number v-model.trim="data.v1x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="title01" style="text-align: center">一般企业</td>
            <td class="d8"><el-input-number v-model.trim="data.v1x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9"><el-input-number v-model.trim="data.v1x9.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d10"><el-input-number v-model.trim="data.v1x10.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d11">{{ parseFloatNum(data.v1x11.value) }}</td>
            <td class="d12">{{ parseFloatNum(data.v1x12.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">2</td>
            <td class="title01" style="text-align: center">前九年度</td>
            <td class="niandu">2015</td>
            <td class="d2"><el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4">--</td>
            <td class="d5">--</td>
            <td class="d6"><el-input-number v-model.trim="data.v2x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="title01" style="text-align: center">一般企业</td>
            <td class="d8"><el-input-number v-model.trim="data.v2x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9"><el-input-number v-model.trim="data.v2x9.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d10"><el-input-number v-model.trim="data.v2x10.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d11">{{ parseFloatNum(data.v2x11.value) }}</td>
            <td class="d12">{{ parseFloatNum(data.v2x12.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">3</td>
            <td class="title01" style="text-align: center">前八年度</td>
            <td class="niandu">2016</td>
            <td class="d2"><el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v3x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4">--</td>
            <td class="d5">{{ parseFloatNum(data.v3x5.value) }}</td>
            <td class="d6"><el-input-number v-model.trim="data.v3x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="title01" style="text-align: center">一般企业</td>
            <td class="d8"><el-input-number v-model.trim="data.v3x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9"><el-input-number v-model.trim="data.v3x9.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d10"><el-input-number v-model.trim="data.v3x10.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d11">{{ parseFloatNum(data.v3x11.value) }}</td>
            <td class="d12">{{ parseFloatNum(data.v3x12.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">4</td>
            <td class="title01" style="text-align: center">前七年度</td>
            <td class="niandu">2017</td>
            <td class="d2"><el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v4x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4">--</td>
            <td class="d5">{{ parseFloatNum(data.v4x5.value) }}</td>
            <td class="d6"><el-input-number v-model.trim="data.v4x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="title01" style="text-align: center">一般企业</td>
            <td class="d8"><el-input-number v-model.trim="data.v4x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9"><el-input-number v-model.trim="data.v4x9.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d10"><el-input-number v-model.trim="data.v4x10.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d11">{{ parseFloatNum(data.v4x11.value) }}</td>
            <td class="d12">{{ parseFloatNum(data.v4x12.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">5</td>
            <td class="title01" style="text-align: center">前六年度</td>
            <td class="niandu">2018</td>
            <td class="d2"><el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v5x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4">--</td>
            <td class="d5">{{ parseFloatNum(data.v5x5.value) }}</td>
            <td class="d6"><el-input-number v-model.trim="data.v5x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="title01" style="text-align: center">一般企业</td>
            <td class="d8"><el-input-number v-model.trim="data.v5x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9"><el-input-number v-model.trim="data.v5x9.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d10"><el-input-number v-model.trim="data.v5x10.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d11">{{ parseFloatNum(data.v5x11.value) }}</td>
            <td class="d12">{{ parseFloatNum(data.v5x12.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">6</td>
            <td class="title01" style="text-align: center">前五年度</td>
            <td class="niandu">2019</td>
            <td class="d2"><el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v6x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v6x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5">{{ parseFloatNum(data.v6x5.value) }}</td>
            <td class="d6"><el-input-number v-model.trim="data.v6x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="title01" style="text-align: center">一般企业</td>
            <td class="d8"><el-input-number v-model.trim="data.v6x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9"><el-input-number v-model.trim="data.v6x9.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d10"><el-input-number v-model.trim="data.v6x10.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d11">{{ parseFloatNum(data.v6x11.value) }}</td>
            <td class="d12">{{ parseFloatNum(data.v6x12.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">7</td>
            <td class="title01" style="text-align: center">前四年度</td>
            <td class="niandu">2020</td>
            <td class="d2"><el-input-number v-model.trim="data.v7x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3"><el-input-number v-model.trim="data.v7x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v7x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5">{{ parseFloatNum(data.v7x5.value) }}</td>
            <td class="d6"><el-input-number v-model.trim="data.v7x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="title01" style="text-align: center">一般企业</td>
            <td class="d8"><el-input-number v-model.trim="data.v7x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9"><el-input-number v-model.trim="data.v7x9.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d10"><el-input-number v-model.trim="data.v7x10.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d11">{{ parseFloatNum(data.v7x11.value) }}</td>
            <td class="d12">{{ parseFloatNum(data.v7x12.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">8</td>
            <td class="title01" style="text-align: center">前三年度</td>
            <td class="niandu">2021</td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v8x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v8x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v8x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v8x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d3"><el-input-number v-model.trim="data.v8x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v8x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5">{{ parseFloatNum(data.v8x5.value) }}</td>
            <td class="d6"><el-input-number v-model.trim="data.v8x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="title01" style="text-align: center">一般企业</td>
            <td class="d8"><el-input-number v-model.trim="data.v8x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9"><el-input-number v-model.trim="data.v8x9.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d10"><el-input-number v-model.trim="data.v8x10.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d11">{{ parseFloatNum(data.v8x11.value) }}</td>
            <td class="d12">{{ parseFloatNum(data.v8x12.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">9</td>
            <td class="title01" style="text-align: center">前二年度</td>
            <td class="niandu">2022</td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v9x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v9x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v9x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v9x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d3"><el-input-number v-model.trim="data.v9x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v9x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5">{{ parseFloatNum(data.v9x5.value) }}</td>
            <td class="d6"><el-input-number v-model.trim="data.v9x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="title01" style="text-align: center">一般企业</td>
            <td class="d8"><el-input-number v-model.trim="data.v9x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9"><el-input-number v-model.trim="data.v9x9.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d10"><el-input-number v-model.trim="data.v9x10.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d11">{{ parseFloatNum(data.v9x11.value) }}</td>
            <td class="d12">{{ parseFloatNum(data.v9x12.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">10</td>
            <td class="title01" style="text-align: center">前一年度</td>
            <td class="niandu">2023</td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v10x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v10x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v10x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d3"><el-input-number v-model.trim="data.v10x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v10x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5">{{ parseFloatNum(data.v10x5.value) }}</td>
            <td class="d6"><el-input-number v-model.trim="data.v10x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="title01" style="text-align: center">一般企业</td>
            <td class="d8">
              <!-- 考题 -->
              <taxQue :data="data.v10x8" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v10x8.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v10x8.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v10x8.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d9">
              <!-- 考题 -->
              <taxQue :data="data.v10x9" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v10x9.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v10x9.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v10x9.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d10">
              <!-- 考题 -->
              <taxQue :data="data.v10x10" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v10x10.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v10x10.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v10x10.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d11">{{ parseFloatNum(data.v10x11.value) }}</td>
            <td class="d12">{{ parseFloatNum(data.v10x12.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">11</td>
            <td class="title01" style="text-align: center">本年度</td>
            <td class="niandu">2024</td>
            <td class="d2">
              <!-- 关联数据 -->
              <!-- 关联企业所得税年度纳税申报主表24行数据 -->
              <!-- 考题 -->
              <taxQue :data="data.v11x2" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v11x2.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v11x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v11x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d3"><el-input-number v-model.trim="data.v11x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d4"><el-input-number v-model.trim="data.v11x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5">{{ parseFloatNum(data.v11x5.value) }}</td>
            <td class="d6"><el-input-number v-model.trim="data.v11x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="title01" style="text-align: center">一般企业</td>
            <td class="d8"><el-input-number v-model.trim="data.v11x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d9"><el-input-number v-model.trim="data.v11x9.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d10">
              <!-- 考题 -->
              <taxQue :data="data.v11x10" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v11x10.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v11x10.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v11x10.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d11">{{ parseFloatNum(data.v11x11.value) }}</td>
            <td class="d12">{{ parseFloatNum(data.v11x12.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">12</td>
            <td colspan="12" class="td_l title01">可结转以后年度弥补的亏损额合计</td>
            <td class="d2">{{ parseFloatNum(data.v12x12.value) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep, includes } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";
import { syncAnswer } from "../../cmjs/index.js";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

const watchData = computed(() => cloneDeep(data.value));
function watchStart() {
  watch(
    watchData,
    (newVal, oldVal) => {
      try {
        // 10行第8列 = 10行第2列 若为负数 直接取值 若为正数 取0
        data.value.v10x8.value = new Big(Math.min(data.value.v10x2.value, 0)).round(2).toNumber();
        // 10行第9列 = 10行第2列 若为负数 直接取值 若为正数 取0
        data.value.v10x9.value = new Big(Math.min(data.value.v10x2.value, 0)).round(2).toNumber();

        // 若11行2列 <= 0 则11行10列=0 10行10列=11行10列

        // A = 11行2列
        const A = data.value.v11x2;
        // B = 11行10列
        const B = data.value.v11x10;
        // C = 10行10列
        const C = data.value.v10x10;
        // D = 10行9列
        const D = data.value.v10x9;
        /* if (new Big(A.value).lte(0)) {
          // 若A≤0 则B=0 C=B
          B.value = 0;
          C.value = B.value;
        } else {
          if (new Big(A.value).lte(Math.abs(D.value))) {
            // 若A＞0且A≤D的绝对值，则B=A C=B
            B.value = A.value;
            C.value = B.value;
          } else {
            // 若A＞0且A＞D的绝对值， 则B=D的绝对值 C=B
            B.value = Math.abs(D.value);
            C.value = B.value;
          }
        } */

        // 新规则
        // 若A≤0 则C=0 B=1-10行合计
        // 若A＞0且A≤D的绝对值，则C=A B=1-10行合计
        // 若A＞0且A＞D的绝对值， 则C=D的绝对值 B=1-10行合计
        if (new Big(A.value).lte(0)) {
          // 若A≤0 则C=0
          C.value = 0;
        } else {
          if (new Big(A.value).lte(Math.abs(D.value))) {
            // 若A＞0且A≤D的绝对值，则C=A
            C.value = A.value;
          } else {
            // 若A＞0且A＞D的绝对值， 则C=D的绝对值
            C.value = Math.abs(D.value);
          }
        }

        // B=1-10行合计
        let res1 = new Big(0);
        for (let row = 1; row <= 10; row++) {
          res1 = res1.plus(data.value[`v${row}x10`].value);
        }

        B.value = res1.round(2).toNumber();

        syncAnswer({
          mode,
          newVal,
          oldVal,
          data,
        });
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1300px !important;
}
</style>

<script>
const tableHtml = `
<table border="1" cellspacing="0" cellpadding="4" tabletype="2024033103">
  <thead>
    <tr>
      <td class="title01" rowspan="3">行次</td>
      <td class="title01" rowspan="3">项&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;目</td>
      <td class="title01 niandu" rowspan="2">年度</td>
      <td class="title01" rowspan="2">当年境内所得额</td>
      <td class="title01" rowspan="2">分立转出的亏损额</td>
      <td class="title01" colspan="3">合并、分立转入的亏损额</td>
      <td class="title01" rowspan="2">弥补亏损企业类型</td>
      <td rowspan="2" class="title01">当年亏损额</td>
      <td class="title01" rowspan="2">当年待弥补的亏损额</td>
      <td colspan="2" class="title01">用本年度所得额弥补的以前年度亏损额</td>
      <td class="title01" rowspan="2">当年可结转以后年度 弥补的亏损额</td>
    </tr>
    <tr>
      <td class="title01">可弥补年限5年</td>
      <td class="title01">可弥补年限8年</td>
      <td class="title01">可弥补年限10年</td>
      <td class="title01">使用境内所得弥补</td>
      <td class="title01">使用境外所得弥补</td>
    </tr>
    <tr>
      <td class="title01 niandu">1</td>
      <td class="title01">2</td>
      <td class="title01">3</td>
      <td class="title01">4</td>
      <td class="title01">5</td>
      <td class="title01">6</td>
      <td class="title01">7</td>
      <td class="title01">8</td>
      <td class="title01">9</td>
      <td class="title01">10</td>
      <td class="title01">11</td>
      <td class="title01">12</td>
    </tr>
  </thead>
  <tbody>
    <tr class="tr">
      <td class="title01">1</td>
      <td class="title01" style="text-align: center">前十年度</td>
      <td class="niandu"><input class="input1" type="text" name="Main" style="text-align: center" isqc="0" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 num i2_17 k1" qc="0" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 num i3_17" isqc="0" daan="0.00" /></td>
      <td class="d4">*</td>
      <td class="d5">*</td>
      <td class="d6"><input type="text" value="0" class="i6 num i6_17 input2" isqc="0" daan="0.00" /></td>
      <td class="title01" style="text-align: center">一般企业</td>
      <td class="d8"><input type="text" value="0" class="i8 num i8_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 num i9_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d10"><input type="text" value="0" class="i10 num i10_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d11"><input type="text" value="0" class="i11 num i11_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d12"><input type="text" value="0" class="num i12_17 input1" isqc="0" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">2</td>
      <td class="title01" style="text-align: center">前九年度</td>
      <td class="niandu"><input class="input1" type="text" name="Main" style="text-align: center" isqc="0" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 num i2_17 k2" qc="0" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 num i3_17" isqc="0" daan="0.00" /></td>
      <td class="d4">*</td>
      <td class="d5">*</td>
      <td class="d6"><input type="text" value="0" class="i6 num i6_17 input2" isqc="0" daan="0.00" /></td>
      <td class="title01" style="text-align: center">一般企业</td>
      <td class="d8"><input type="text" value="0" class="i8 num i8_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 num i9_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d10"><input type="text" value="0" class="i10 num i10_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d11"><input type="text" value="0" class="i11 num i11_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d12"><input type="text" value="0" class="i12 num i12_17 input1" isqc="0" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">3</td>
      <td class="title01" style="text-align: center">前八年度</td>
      <td class="niandu"><input class="input1" type="text" name="Main" style="text-align: center" isqc="0" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 num i2_17 k3" qc="0" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 num i3_17" isqc="0" daan="0.00" /></td>
      <td class="d4">*</td>
      <td class="d5"><input type="text" value="0" class="i5 num i5_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num i6_17 input2" isqc="0" daan="0.00" /></td>
      <td class="title01" style="text-align: center">一般企业</td>
      <td class="d8"><input type="text" value="0" class="i8 num i8_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 num i9_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d10"><input type="text" value="0" class="i10 num i10_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d11"><input type="text" value="0" class="i11 num i11_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d12"><input type="text" value="0" class="i12 num i12_17 input1" isqc="0" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">4</td>
      <td class="title01" style="text-align: center">前七年度</td>
      <td class="niandu"><input class="input1" type="text" name="Main" style="text-align: center" isqc="0" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 num i2_17 k4" qc="0" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 num i3_17" isqc="0" daan="0.00" /></td>
      <td class="d4">*</td>
      <td class="d5"><input type="text" value="0" class="i5 num i5_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num i6_17 input2" isqc="0" daan="0.00" /></td>
      <td class="title01" style="text-align: center">一般企业</td>
      <td class="d8"><input type="text" value="0" class="i8 num i8_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 num i9_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d10"><input type="text" value="0" class="i10 num i10_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d11"><input type="text" value="0" class="i11 num i11_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d12"><input type="text" value="0" class="i12 num i12_17 input1" isqc="0" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">5</td>
      <td class="title01" style="text-align: center">前六年度</td>
      <td class="niandu"><input class="input1" type="text" name="Main" style="text-align: center" isqc="0" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 num i2_17 k5" qc="0" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 num i3_17" isqc="0" daan="0.00" /></td>
      <td class="d4">*</td>
      <td class="d5"><input type="text" value="0" class="i5 num i5_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num i6_17 input2" isqc="0" daan="0.00" /></td>
      <td class="title01" style="text-align: center">一般企业</td>
      <td class="d8"><input type="text" value="0" class="i8 num i8_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 num i9_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d10"><input type="text" value="0" class="i10 num i10_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d11"><input type="text" value="0" class="i11 num i11_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d12"><input type="text" value="0" class="i12 num i12_17 input1" isqc="0" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">6</td>
      <td class="title01" style="text-align: center">前五年度</td>
      <td class="niandu"><input class="input1" type="text" name="Main" style="text-align: center" isqc="0" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 num i2_17 k6" qc="0" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 num i3_17" isqc="0" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 num i4_17 input2" qc="0" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 num i5_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num i6_17 input2" isqc="0" daan="0.00" /></td>
      <td class="title01" style="text-align: center">一般企业</td>
      <td class="d8"><input type="text" value="0" class="i8 num i8_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 num i9_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d10"><input type="text" value="0" class="i10 num i10_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d11"><input type="text" value="0" class="i11 num i11_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d12"><input type="text" value="0" class="i12 num i12_17 input1" isqc="0" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">7</td>
      <td class="title01" style="text-align: center">前四年度</td>
      <td class="niandu"><input class="input1" type="text" name="Main" style="text-align: center" isqc="0" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 num i2_17 k7" qc="0" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 num i3_17" isqc="0" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 num i4_17 input2" qc="0" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 num i5_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num i6_17 input2" isqc="0" daan="0.00" /></td>
      <td class="title01" style="text-align: center">一般企业</td>
      <td class="d8"><input type="text" value="0" class="i8 num i8_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 num i9_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d10"><input type="text" value="0" class="i10 num i10_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d11"><input type="text" value="0" class="i11 num i11_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d12"><input type="text" value="0" class="i12 num i12_17 input1" isqc="0" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">8</td>
      <td class="title01" style="text-align: center">前三年度</td>
      <td class="niandu"><input class="input1" type="text" name="Main" style="text-align: center" isqc="0" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 num i2_17 k8" qc="0" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 num i3_17" isqc="452691.55" daan="452691.55" /></td>
      <td class="d4"><input type="text" value="0" class="i4 num i4_17 input2" qc="0" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 num i5_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num i6_17 input2" isqc="0" daan="0.00" /></td>
      <td class="title01" style="text-align: center">一般企业</td>
      <td class="d8"><input type="text" value="0" class="i8 num i8_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 num i9_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d10"><input type="text" value="0" class="i10 num i10_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d11"><input type="text" value="0" class="i11 num i11_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d12"><input type="text" value="0" class="i12 num i12_17 input1" isqc="0" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">9</td>
      <td class="title01" style="text-align: center">前二年度</td>
      <td class="niandu"><input class="input1" type="text" name="Main" style="text-align: center" isqc="0" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 num i2_17 k9" qc="0" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 num i3_17" isqc="660656.95" daan="660656.95" /></td>
      <td class="d4"><input type="text" value="0" class="i4 num i4_17 input2" qc="0" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 num i5_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num i6_17 input2" isqc="0" daan="0.00" /></td>
      <td class="title01" style="text-align: center">一般企业</td>
      <td class="d8"><input type="text" value="0" class="i8 num i8_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 num i9_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d10"><input type="text" value="0" class="i10 num i10_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d11"><input type="text" value="0" class="i11 num i11_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d12"><input type="text" value="0" class="i12 num i12_17 input1" isqc="0" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">10</td>
      <td class="title01" style="text-align: center">前一年度</td>
      <td class="niandu"><input class="input1" type="text" name="Main" style="text-align: center" isqc="0" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 num i2_17 k10" id="qci2" qc="0" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 num i3_17" isqc="-12763.88" daan="-12763.88" /></td>
      <td class="d4"><input type="text" value="0" class="i4 num i4_17 input2" qc="0" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 num i5_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num i6_17 input2" isqc="0" daan="0.00" /></td>
      <td class="title01" style="text-align: center">一般企业</td>
      <td class="d8"><input type="text" value="0" class="i8 num i8_17 input1" id="qci8" isqc="-12763.88" daan="-12763.88" /></td>
      <td class="d9"><input type="text" value="0" class="i9 num i9_17 input1" id="qci9" isqc="-12763.88" daan="-12763.88" /></td>
      <td class="d10"><input type="text" value="0" class="i10 num i10_17 input1" id="qci10" isqc="0" daan="0.00" /></td>
      <td class="d11"><input type="text" value="0" class="i11 num i11_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d12"><input type="text" value="0" class="i12 num i12_17 input1" isqc="12763.88" daan="12763.88" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">11</td>
      <td class="title01" style="text-align: center">本年度</td>
      <td class="niandu"><input style="text-align: center" type="text" class="input1 year" isqc="0" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="input1 i2 num i2_17 k11" qc="0" daan="734212.18" /></td>
      <td class="d3"><input type="text" value="0" class="input2 i3 num i3_17" isqc="0" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 num i4_17 input2" qc="0" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 num i5_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num i6_17 input2" isqc="0" daan="0.00" /></td>
      <td class="title01" style="text-align: center">一般企业</td>
      <td class="d8"><input type="text" value="0" class="i8 num i8_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d9"><input type="text" value="0" class="i9 n9 num i9_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d10"><input type="text" value="0" class="i10s num i10_17 input1" readonly="" isqc="0" daan="0.00" /></td>
      <td class="d11"><input type="text" value="0" class="i11 num i11_17 input1" isqc="0" daan="0.00" /></td>
      <td class="d12"><input type="text" value="0" class="n12 num i12_17 input1" isqc="0" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">12</td>
      <td colspan="12" class="td_l title01">可结转以后年度弥补的亏损额合计</td>
      <td class="d2"><input type="text" class="input1" value="0" readonly="" qc="0" daan="0.00" /></td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input.*type="text".*none.*>/g, "");
  s = s.replace(/<input type="text".*>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
